<div class="wrapper">
  <div
    id="sidebar-menu"
    class="gms-container"
    [ngClass]="{ expanded: this.expanded, collapsed: !this.expanded }"
  >
    <ng-content></ng-content>
  </div>
  <div class="expand-button-wrapper">
    <div
      tabindex="0"
      (keydown.enter)="onExpanderClick()"
      (click)="onExpanderClick()"
      class="expand-button-container"
      id="expand-button"
    >
      <img src="assets/svg/expand-btn.svg" *ngIf="!this.expanded" alt="" />
      <img src="assets/svg/collapse-btn.svg" *ngIf="this.expanded" alt="" />
    </div>
  </div>
</div>
